module.exports = __webpack_public_path__ + "static/media/apple-touch-startup-image-750x1334.efe7798b.png";